import Lang from 'lang.js';

const plugin = {
  install(Vue, options) {

    // Default options
    const Locale = options.locale || 'en'
    const fallbackLocale = options.fallback || 'en'
    const messages = options.messages || {}

    const lang = new Lang({
      messages: messages,
      locale: Locale,
      fallback: fallbackLocale
    });

    Object.defineProperty(Vue.config.globalProperties, '$lang', {
      get: function () {
        return this.$root._lang
      }
    });

    const translate = (key, data = {}) => {
      const translated = lang.get(key, data);

      // If the key is not in found in the list of messages.
      if (translated === key) {
        // Return the text after the key.
        // Example the key is `profile.This is a test`.
        // This will return the `This is a test`
        return key.substring(key.indexOf('.') + 1);
      }

      return translated;
    };

    const translateChoice = (key, count, data = {}) => {
      const translated = lang.transChoice(key, count, data);

      // If the key is not in found in the list of messages.
      if (translated === key) {
        // Return the text after the key.
        // Example the key is `profile.This is a test`.
        // This will return the `This is a test`
        return key.substring(key.indexOf('.') + 1);
      }

      return translated;
    };

    Vue.mixin({
      methods: {
        trans: translate,
        transChoice: translateChoice
      }
    });

    Vue.provide('trans', translate);
    Vue.provide('transChoice', translateChoice);
  }
};

export default plugin;
